import React, { useState, useEffect } from "react";
import "./ChefMenuModal.css";
import GetAPI from "../../APICalls/GetAPI";
import MenuItems from "./MenuItems";
import { ThreeCircles } from "react-loader-spinner";
import ChefAddMenuModal from "./ChefAddMenuModal";
import ChefEditMenuModal from "./ChefEditMenuModal";


const MenuButton = ({ title, isActive, onClick }) => {
  return (
    <button
      className={`btn m-2 ${isActive ? "btn-primary" : "btn-outline-primary"}`}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

const Tab = ({ title, isActive, onClick }) => {
  return (
    <li className="nav-item" role="presentation">
      <a
        className={`nav-link ${isActive ? "active" : ""}`}
        onClick={onClick}
      >
        {title}
      </a>
    </li>
  );
};

const TabContent = ({ activeComponent, menuItems, setActiveComponent, renderComponent, isActive }) => {
  return (
    <div
      className={`tab-pane fade ${isActive ? "show active" : ""}`}
      role="tabpanel"
    >
      <div className="d-flex flex-wrap justify-content-between mt-3">
        {menuItems.map((item) => (
          <MenuButton
            key={item}
            title={item}
            isActive={activeComponent.toUpperCase() === item.toUpperCase()}
            onClick={() => setActiveComponent(item)}
          />
        ))}
      </div>
      {renderComponent()}
    </div>
  );
};

const ChefMenuModal = ({ show, selectedChefData, handleClose }) => {
  const [activeTab, setActiveTab] = useState("dailyMenu");
  const [activeComponent, setActiveComponent] = useState("Breakfast");
  const [dailyMenu, setDailyMenu] = useState({
    "All Day": { liveItems: 0, totalItems: 0, data: [] },
    Breakfast: { liveItems: 0, totalItems: 0, data: [] },
    Lunch: { liveItems: 0, totalItems: 0, data: [] },
    Dinner: { liveItems: 0, totalItems: 0, data: [] },
    Snacks: { liveItems: 0, totalItems: 0, data: [] },
  });

  const [preOrderMenu, setPreOrderMenu] = useState({
    "All Day": { liveItems: 0, totalItems: 0, data: [] },
    Breakfast: { liveItems: 0, totalItems: 0, data: [] },
    Lunch: { liveItems: 0, totalItems: 0, data: [] },
    Dinner: { liveItems: 0, totalItems: 0, data: [] },
    Snacks: { liveItems: 0, totalItems: 0, data: [] },
  });

  const [searchText, setSearchText] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCurrentModal, setShowCurrentModal] = useState("Menu");
  const [menuID, setMenuID] = useState("");
  const MENU_ITEMS = ["Breakfast", "Lunch", "Dinner", "Snacks", "All Day"];
  const TABS = [
    { id: "dailyMenu", title: "Daily Menu" },
    { id: "preOrderMenu", title: "Pre Order Menu" }
  ];

  let menuAPI;
  const ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  if (ENVIRONMENT?.toUpperCase() === "PRODUCTION") {
    menuAPI = process.env.REACT_APP_PROD_CHEFMENU;
  } else {
    menuAPI = process.env.REACT_APP_DEV_CHEFMENU;
  }

  const refreshMenuData = () => {
    const COMPLETE_USER_URL = `${menuAPI}?userID=${selectedChefData.userID}&type=CHEF_MENUS`;
    GetAPI(COMPLETE_USER_URL)
      .then((res) => {
        if (
          res.data.statusCode === 200 &&
          Object.keys(res.data.body).length > 0
        ) {
          const {
            "Daily Menu": DailyMenu = {},
            "Pre order Menu": PreOrderMenu = {},
          } = res.data.body;

          setDailyMenu({
            "All Day": DailyMenu["All Day"] || dailyMenu["All Day"],
            Breakfast: DailyMenu["Breakfast"] || dailyMenu["Breakfast"],
            Lunch: DailyMenu["Lunch"] || dailyMenu["Lunch"],
            Dinner: DailyMenu["Dinner"] || dailyMenu["Dinner"],
            Snacks: DailyMenu["Snacks"] || dailyMenu["Snacks"],
          });

          setPreOrderMenu({
            "All Day": PreOrderMenu["All Day"] || preOrderMenu["All Day"],
            Breakfast: PreOrderMenu["Breakfast"] || preOrderMenu["Breakfast"],
            Lunch: PreOrderMenu["Lunch"] || preOrderMenu["Lunch"],
            Dinner: PreOrderMenu["Dinner"] || preOrderMenu["Dinner"],
            Snacks: PreOrderMenu["Snacks"] || preOrderMenu["Snacks"],
          });
          setLoading(false);
        } else {
          console.error(res);
          alert("Unable to fetch chef Menu");
          setLoading(false);
        }
      })
      .catch((e) => {
        console.error(e);
        alert("Unable to fetch chef Menu");
        setLoading(false);
      });
  };

  useEffect(() => {
    if(showCurrentModal.toUpperCase() === "MENU") {
      refreshMenuData()
    }
  }, [selectedChefData.userID, showCurrentModal]);

  const handleEdit = (menuIDValue) => {
    setMenuID(menuIDValue);
    setShowCurrentModal("Edit");
  }

  useEffect(() => {
    const SELECTEDMENU = activeTab.toUpperCase() === "DAILYMENU" ? dailyMenu : preOrderMenu;
    const { items } = SELECTEDMENU[activeComponent] || {};

    const filtered =
      items?.filter((item) =>
        item?.itemName?.toLowerCase().includes(searchText.toLowerCase())
      ) || [];

    setFilteredItems(filtered);
  }, [searchText, activeTab, activeComponent, dailyMenu, preOrderMenu]);

  const renderComponent = () => {
    const CURRENTDATA = activeTab.toUpperCase() === "DAILYMENU" ? dailyMenu[activeComponent]?.data : preOrderMenu[activeComponent]?.data;
    
    const MENUDATA = filteredItems || CURRENTDATA;
  
    const LIVEITEMS = activeTab.toUpperCase() === "DAILYMENU" ? dailyMenu[activeComponent]?.liveItems : preOrderMenu[activeComponent]?.liveItems;
    const TOTALITEMS = activeTab.toUpperCase() === "DAILYMENU" ? dailyMenu[activeComponent]?.totalItems : preOrderMenu[activeComponent]?.totalItems;
  
    return (
      <div>
        <div className="d-flex justify-content-between">
          <h5 style={{ color: 'black', fontSize: '1.25rem' }}>Showing {activeComponent} Menus</h5>
          <h5 style={{ color: 'black', fontSize: '1.25rem' }}>{`Items Live: ${LIVEITEMS}/${TOTALITEMS}`}</h5>
        </div>
        <div className="menu-card-container">
          {MENUDATA && MENUDATA.length > 0 ? (
            MENUDATA.map(item => (
              <MenuItems 
                key={item.itemID} 
                item={item} 
                selected={activeTab} 
                selectedMenuType={activeComponent} 
                setLoading={setLoading} 
                menuAPI={menuAPI}
                refreshMenuData={refreshMenuData}
                handleEdit={handleEdit}
                isXpress={selectedChefData.isXpress}
              />
            ))
          ) : (
            <p>No items available</p>
          )}
        </div>
      </div>
    );
  };  

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ display: show ? "block" : "none" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          {loading && (
            <div className="spinnerContainer">
              <div className="spinner">
                <ThreeCircles
                  color="blue"
                  height={110}
                  width={110}
                  ariaLabel="three-circles-rotating"
                />
              </div>
            </div>
          )}
          {showCurrentModal.toUpperCase() == "ADD" ? (
            <ChefAddMenuModal
              showAdd={showCurrentModal == "Add"}
              handleAddClose={() => setShowCurrentModal("Menu")}
              selectedChefData={selectedChefData}
            />
          ) : null}
          {showCurrentModal.toUpperCase() == "EDIT" && menuID !== "" ? (
            <ChefEditMenuModal
              showEdit={showCurrentModal == "Edit"}
              handleAddClose={() => setShowCurrentModal("Menu")}
              selectedChefData={selectedChefData}
              menuID={menuID}
            />
          ) : null}
          <div className="modal-header">
            <h5
              className="modal-title"
              style={{ color: "black", fontSize: "1.25rem" }}
            >{`${selectedChefData.userName}'s Menu Manager`}</h5>
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={() => setShowCurrentModal("Add")}
            >
              + Add Item
            </button>
            <button type="button" className="close" onClick={handleClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          {/* Search input added here */}
          <div className="modal-body">
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search by item name..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <div>
              <ul className="nav nav-tabs" id="nav-tab" role="tablist">
                {TABS.map((tab) => (
                  <Tab
                    key={tab.id}
                    title={tab.title}
                    isActive={activeTab.toUpperCase() === tab.id.toUpperCase()}
                    onClick={() => setActiveTab(tab.id)}
                  />
                ))}
              </ul>
              <div className="tab-content mt-3">
                <div className="tab-content mt-3">
                  <TabContent
                    activeComponent={activeComponent}
                    menuItems={MENU_ITEMS}
                    setActiveComponent={setActiveComponent}
                    renderComponent={renderComponent}
                    isActive={activeTab.toUpperCase() === "DAILYMENU"}
                  />
                  <TabContent
                    activeComponent={activeComponent}
                    menuItems={MENU_ITEMS}
                    setActiveComponent={setActiveComponent}
                    renderComponent={renderComponent}
                    isActive={activeTab.toUpperCase() === "PREORDERMENU"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChefMenuModal;
